"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubTaskListCard = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_2 = require("@sierralabs/core");
const core_ui_1 = require("@sierralabs/core-ui");
const workflow_core_1 = require("@sierralabs/workflow-core");
const useWorkflowGroupPermissions_1 = require("../../hooks/useWorkflowGroupPermissions");
const TaskStatusLabel_1 = __importDefault(require("../components/TaskStatusLabel"));
const TaskAssignDialog_1 = __importDefault(require("../dialogs/TaskAssignDialog"));
const useCreateSubTasks_1 = require("../hooks/useCreateSubTasks");
const useReassignSubTasks_1 = require("../hooks/useReassignSubTasks");
const StyledTableRow = (0, styled_components_1.default)(core_1.TableRow) `
  &.locked {
    opacity: 0.6;
    background-color: ${props => props.theme.palette.grey[100]};
  }
  &.selected {
    background-color: ${props => props.theme.palette.action.hover};
  }
  &:not(.selected) .MuiTableCell-root {
    border-bottom: none;
  }
  .actions {
    padding: 2px;
  }
  .cell-secondary-text {
    white-space: normal;
  }
`;
const SubTaskListCard = props => {
    var _a;
    const { task, title = 'SubTasks', dialogTitle, dialogMessage, cardProps, onChange, onError } = props;
    const onChangeRef = (0, react_1.useRef)(onChange);
    onChangeRef.current = onChange;
    const onErrorRef = (0, react_1.useRef)(onError);
    onErrorRef.current = onError;
    const childrenRef = (0, react_1.useRef)(task.children || []);
    childrenRef.current = task.children || [];
    const [selected, setSelected] = (0, react_1.useState)();
    const [assignProps, setAssignProps] = (0, react_1.useState)();
    const { groupIds, canReassign } = (0, useReassignSubTasks_1.useReassignSubTasks)(task);
    const { hasGroupPermissions } = (0, useWorkflowGroupPermissions_1.useWorkflowGroupPermissions)(task);
    const { data, isLoading, error, createSubTasks } = (0, useCreateSubTasks_1.useCreateSubTasks)(task.id);
    const disabled = props.disabled || isLoading;
    // make sure to use legacy checks if subTasks of the main task have no groups
    // this is used when reassigning old existing subtasks
    // before the subTask.group implementation
    const isLegacyAssignment = task.children &&
        task.children.length > 0 &&
        task.children.every(subTask => !subTask.group);
    // active subTasks are subTasks with a statePath
    // that matches the current main task.status
    const hasActiveSubTasks = (task.children || []).some(subTask => {
        return (!subTask.statePath || (0, workflow_core_1.compareTaskStatus)(subTask.statePath, task.status));
    });
    const { lockedUsers, preselectedUsers } = (0, react_1.useMemo)(() => {
        const subTasks = task.children || [];
        // get all subTasks except for reassigning subTask
        const lockedUsers = [];
        // preselect non-locked selected users
        // for ease of updating the assigned group or optional flag
        const preselectedUsers = [];
        for (const subTask of subTasks) {
            // make sure subTask belongs to current task.status
            if (!subTask.user || !(0, workflow_core_1.isSubTaskInActiveStatePath)(subTask, task)) {
                continue;
            }
            const item = {
                id: subTask.id,
                version: subTask.version,
                user: subTask.user,
                group: subTask.group,
                statePath: subTask.statePath,
                isOptional: subTask.isOptional
            };
            // all items are locked except for the item to be reassigned
            const isLocked = !(assignProps === null || assignProps === void 0 ? void 0 : assignProps.reassign) || assignProps.taskId !== subTask.id;
            const array = isLocked ? lockedUsers : preselectedUsers;
            array.push(item);
        }
        return { lockedUsers, preselectedUsers };
    }, [assignProps, task]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!data) {
            return;
        }
        const children = Array.from(childrenRef.current);
        for (const subTask of data.created.concat(data.updated)) {
            const index = children.findIndex(child => child.id === subTask.id);
            if (index > -1) {
                children[index] = Object.assign(Object.assign({}, children[index]), subTask);
            }
            else {
                // add as first entry
                children.unshift(subTask);
            }
        }
        (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, { children });
    }, [data]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (error) {
            (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, error);
        }
    }, [error]);
    return (react_1.default.createElement(core_1.Card, Object.assign({}, cardProps),
        isLoading && react_1.default.createElement(core_1.LinearProgress, null),
        react_1.default.createElement(core_ui_1.CardTitle, null,
            react_1.default.createElement(icons_1.AssignmentTurnedIn, null),
            title),
        react_1.default.createElement(core_1.TableContainer, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { width: 1 }),
                        react_1.default.createElement(core_1.TableCell, null, "Assigned"),
                        react_1.default.createElement(core_1.TableCell, null, "Status"),
                        react_1.default.createElement(core_1.TableCell, null, "Date and Time"))),
                react_1.default.createElement(core_1.TableBody, null,
                    (!task.children || task.children.length === 0) && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 4 }, "No Sub Tasks assigned"))), (_a = task.children) === null || _a === void 0 ? void 0 :
                    _a.map(subTask => {
                        var _a, _b;
                        const enabled = !disabled && canReassign(subTask);
                        const isLocked = !(0, workflow_core_1.isSubTaskInActiveStatePath)(subTask, task);
                        const isSelected = selected === subTask.id;
                        const classes = [];
                        // only include locked styling if there are also active subTasks
                        isLocked && hasActiveSubTasks && classes.push('locked');
                        isSelected && classes.push('selected');
                        return (react_1.default.createElement(react_1.Fragment, { key: subTask.id },
                            react_1.default.createElement(StyledTableRow, { hover: enabled, className: classes.join(' '), onClick: () => {
                                    if (enabled) {
                                        setAssignProps({ taskId: subTask.id, reassign: true });
                                    }
                                } },
                                react_1.default.createElement(core_1.TableCell, { className: 'actions', padding: 'none' },
                                    react_1.default.createElement(core_1.IconButton, { size: 'small', disabled: !subTask.reason, onClick: event => {
                                            event.stopPropagation();
                                            setSelected(selected !== subTask.id ? subTask.id : undefined);
                                        } }, isSelected ? react_1.default.createElement(icons_1.ArrowDropDown, null) : react_1.default.createElement(icons_1.ArrowRight, null))),
                                react_1.default.createElement(core_1.TableCell, null, (_a = subTask.user) === null || _a === void 0 ? void 0 :
                                    _a.firstName,
                                    " ", (_b = subTask.user) === null || _b === void 0 ? void 0 :
                                    _b.lastName,
                                    subTask.group && (react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary', className: 'cell-secondary-text' }, subTask.group.name)),
                                    subTask.isOptional && (react_1.default.createElement(core_1.Typography, { display: 'block', variant: 'caption', color: 'textSecondary' }, "(optional)"))),
                                react_1.default.createElement(core_1.TableCell, null,
                                    react_1.default.createElement(TaskStatusLabel_1.default, { task: subTask }),
                                    isLocked && subTask.statePath && (react_1.default.createElement(core_1.Typography, { variant: 'body2', color: 'textSecondary', className: 'cell-secondary-text' },
                                        "from v",
                                        subTask.version,
                                        ' ',
                                        react_1.default.createElement("strong", null, (0, workflow_core_1.parseTaskStatus)(subTask.statePath))))),
                                react_1.default.createElement(core_1.TableCell, null, (0, core_2.formatDate)(subTask.modified))),
                            react_1.default.createElement(core_1.TableRow, null,
                                react_1.default.createElement(core_1.TableCell, { colSpan: 4, padding: 'none' }, subTask.reason && (react_1.default.createElement(core_1.Collapse, { in: isSelected },
                                    react_1.default.createElement(core_ui_1.HoveredCard, { icon: react_1.default.createElement(icons_1.Notes, null), title: 'Reason for Rejection', content: react_1.default.createElement(core_1.Typography, { variant: 'body1' }, subTask.reason) })))))));
                    })))),
        react_1.default.createElement(core_1.CardActions, { style: { padding: 16 } },
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'outlined', disabled: disabled || !hasGroupPermissions, onClick: () => setAssignProps({ taskId: task.id, reassign: false }) }, "Add Reviewers")),
        assignProps && (react_1.default.createElement(TaskAssignDialog_1.default, { open: true, title: dialogTitle, message: dialogMessage, taskId: assignProps.taskId, multiple: !assignProps.reassign, 
            // always apply groupIds for new behavior
            groupIds: !isLegacyAssignment || assignProps.reassign ? groupIds : undefined, parentTask: task, lockedUsers: lockedUsers, initialUsers: preselectedUsers, isLegacyAssignment: isLegacyAssignment, onCancel: () => setAssignProps(undefined), onAssign: subTask => {
                const children = Array.from(task.children || []);
                const index = children.findIndex(subTask => subTask.id === assignProps.taskId);
                if (index > -1) {
                    console.log('replace child task', subTask);
                    children.splice(index, 1, subTask);
                    // trigger update
                    onChange === null || onChange === void 0 ? void 0 : onChange({ children });
                }
                setAssignProps(undefined);
            }, handleAssign: subTaskUsers => {
                setAssignProps(undefined);
                if (subTaskUsers.length > 0) {
                    createSubTasks({ subTaskUsers });
                }
            } }))));
};
exports.SubTaskListCard = SubTaskListCard;
exports.default = exports.SubTaskListCard;
//# sourceMappingURL=SubTaskListCard.js.map